module.exports = __webpack_public_path__ + "img/cimientos_de_microconcreto.38e7436e.png";